<script>
import store from '@state/store'
import Layout from '@layouts/guest.vue'
import { authMethods, authComputed } from '@state/helpers'
import LoginForm from '@guest/components/login-form.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Log in to PENCIL` }],
  },
  components: { Layout, LoginForm },
  data() {
    return {
      username: '',
      password: '',
      authError: '',
      signUpError: '',
    }
  },
  computed: { ...authComputed },
  methods: {
    ...authMethods,
    postLogin(params) {
      this.authError = ''
      return this.logIn({
        username: params.username,
        password: params.password,
        rememberMe: params.rememberMe,
      }).then((response) => {
        if (response.error) {
          this.authError = response.error
        } else {
          var user = response
          if (user.token) {
            this.redirectFunc()
          }
        }
      })
    },
    postLoginWithProvider(params) {
      this.authError = ''
      return this.logInWithProvider({
        name: params.name,
        email: params.email,
        imageUrl: params.image_url,
        idToken: params.id_token,
        userId: params.user_id,
        loginProvider: params.login_provider,
      }).then((response) => {
        if (response.error) {
          this.authError = response.error
        } else {
          var user = response
          if (user.token) {
            this.redirectFunc()
          }
        }
      })
    },
    redirectFunc() {
      store.dispatch('auth/validate', true).then((user) => {
        localStorage.removeItem('LAST_VISITED_COMPANY_ID')
        const companyId =
          user.default_company_id && user.default_company_id !== 0
            ? user.default_company_id
            : 2944
        var goToRoute = {
          name: 'company',
          params: { companyId },
        }
        if (user.phone === '') {
          goToRoute = { name: 'verify-phone' }
        }
        // Redirect to the originally requested page, or to the default company or to phone verification
        this.$router.push(this.$route.query.redirectFrom || goToRoute)
      })
    },
    postSignup(params) {
      this.signUpError = ''
      return this.signUp({
        email: params.email,
        newPassword: params.newPassword,
        fullName: params.fullName,
        zipCode: params.zipCode,
        userCompany: params.userCompany,
      }).then((response) => {
        if (response.error) {
          this.signUpError = response.error
        } else {
        }
      })
    },
    clearAuthErrors() {
      this.authError = ''
    },
    clearSignUpErrors() {
      this.signUpError = ''
    },
  },
}
</script>

<template>
  <Layout>
    <LoginForm
      :auth-error="authError"
      :sign-up-error="signUpError"
      :is-trying-to-login="isTryingToLogin"
      @post-login="postLogin"
      @post-login-with-provider="postLoginWithProvider"
      @post-signup="postSignup"
      @clear-auth-errors="clearAuthErrors"
      @clear-sign-up-errors="clearSignUpErrors"
    ></LoginForm>
  </Layout>
</template>
